/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable camelcase */

const EMPTY_OBJECT = Object.create(null);
export class UouChatMessages {
  constructor(translator) {
    this.translator = translator;
  }
  _translate(key, params) {
    return this.translator.translate(key, params);
  }
  _translateWithChildren(key, params, children) {
    return this.translator.translateWithChildren(key, params, children);
  }
  ASA_STANDALONE_CHAT_NOW_DIVIDER() {
    return this._translate('ASA_STANDALONE_CHAT_NOW_DIVIDER', EMPTY_OBJECT);
  }
  ASA_STANDALONE_HEADER_SUB_TITLE() {
    return this._translate('ASA_STANDALONE_HEADER_SUB_TITLE', EMPTY_OBJECT);
  }
  ASA_STANDALONE_HEADER_MENU_DISCONNECT_CTA() {
    return this._translate('ASA_STANDALONE_HEADER_MENU_DISCONNECT_CTA', EMPTY_OBJECT);
  }
  ASA_STANDALONE_FOOTER_TITLE() {
    return this._translate('ASA_STANDALONE_FOOTER_TITLE', EMPTY_OBJECT);
  }
  ASA_STANDALONE_FOOTER_DISCLAIMER() {
    return this._translate('ASA_STANDALONE_FOOTER_DISCLAIMER', EMPTY_OBJECT);
  }
  ASA_STANDALONE_CHAT_MESSAGE_TO_SEND_PLACEHOLDER() {
    return this._translate('ASA_STANDALONE_CHAT_MESSAGE_TO_SEND_PLACEHOLDER', EMPTY_OBJECT);
  }
  ASA_STANDALONE_CHAT_SPLASH_FRAME1_LINE1(name) {
    return this._translate('ASA_STANDALONE_CHAT_SPLASH_FRAME1_LINE1', {
      name
    });
  }
  ASA_STANDALONE_CHAT_SPLASH_FRAME1_LINE2() {
    return this._translate('ASA_STANDALONE_CHAT_SPLASH_FRAME1_LINE2', EMPTY_OBJECT);
  }
  ASA_STANDALONE_CHAT_SPLASH_FRAME2_LINE1() {
    return this._translate('ASA_STANDALONE_CHAT_SPLASH_FRAME2_LINE1', EMPTY_OBJECT);
  }
  ASA_STANDALONE_CHAT_SPLASH_FRAME2_LINE2() {
    return this._translate('ASA_STANDALONE_CHAT_SPLASH_FRAME2_LINE2', EMPTY_OBJECT);
  }
  ASA_STANDALONE_CHAT_SPLASH_FRAME2_LINE2_NO_BUSINESS_NAME() {
    return this._translate('ASA_STANDALONE_CHAT_SPLASH_FRAME2_LINE2_NO_BUSINESS_NAME', EMPTY_OBJECT);
  }
  ASA_STANDALONE_CHAT_SPLASH_FRAME2_LINE3(businessName) {
    return this._translate('ASA_STANDALONE_CHAT_SPLASH_FRAME2_LINE3', {
      businessName
    });
  }
  ASA_STANDALONE_CONNECT_CALENDAR_WIDGET_CONNECT_CTA() {
    return this._translate('ASA_STANDALONE_CONNECT_CALENDAR_WIDGET_CONNECT_CTA', EMPTY_OBJECT);
  }
  ASA_STANDALONE_CONNECT_CALENDAR_WIDGET_CONNECT_MESSAGE() {
    return this._translate('ASA_STANDALONE_CONNECT_CALENDAR_WIDGET_CONNECT_MESSAGE', EMPTY_OBJECT);
  }
  ASA_STANDALONE_CONNECT_CALENDAR_WIDGET_SKIP_CTA() {
    return this._translate('ASA_STANDALONE_CONNECT_CALENDAR_WIDGET_SKIP_CTA', EMPTY_OBJECT);
  }
  ASA_STANDALONE_CONNECT_CALENDAR_WIDGET_SKIP_MESSAGE() {
    return this._translate('ASA_STANDALONE_CONNECT_CALENDAR_WIDGET_SKIP_MESSAGE', EMPTY_OBJECT);
  }
  ASA_STANDALONE_CHAT_PAYMENT_SUCCESS_MESSAGE() {
    return this._translate('ASA_STANDALONE_CHAT_PAYMENT_SUCCESS_MESSAGE', EMPTY_OBJECT);
  }
  ASA_STANDALONE_CONNECT_CALENDAR_MODAL_TITLE() {
    return this._translate('ASA_STANDALONE_CONNECT_CALENDAR_MODAL_TITLE', EMPTY_OBJECT);
  }
  ASA_STANDALONE_CONNECT_CALENDAR_MODAL_SUBTITLE(name) {
    return this._translate('ASA_STANDALONE_CONNECT_CALENDAR_MODAL_SUBTITLE', {
      name
    });
  }
  ASA_STANDALONE_CONNECT_CALENDAR_MODAL_FOOTNOTE() {
    return this._translate('ASA_STANDALONE_CONNECT_CALENDAR_MODAL_FOOTNOTE', EMPTY_OBJECT);
  }
  ASA_STANDALONE_CONNECT_CALENDAR_MODAL_CONNECT_CTA() {
    return this._translate('ASA_STANDALONE_CONNECT_CALENDAR_MODAL_CONNECT_CTA', EMPTY_OBJECT);
  }
  ASA_STANDALONE_CALENDAR_PROVIDER_GOOGLE_TITLE() {
    return this._translate('ASA_STANDALONE_CALENDAR_PROVIDER_GOOGLE_TITLE', EMPTY_OBJECT);
  }
  ASA_STANDALONE_CALENDAR_PROVIDER_GOOGLE_SUBTITLE() {
    return this._translate('ASA_STANDALONE_CALENDAR_PROVIDER_GOOGLE_SUBTITLE', EMPTY_OBJECT);
  }
  ASA_STANDALONE_CALENDAR_PROVIDER_MICROSOFT_TITLE() {
    return this._translate('ASA_STANDALONE_CALENDAR_PROVIDER_MICROSOFT_TITLE', EMPTY_OBJECT);
  }
  ASA_STANDALONE_CALENDAR_PROVIDER_MICROSOFT_SUBTITLE() {
    return this._translate('ASA_STANDALONE_CALENDAR_PROVIDER_MICROSOFT_SUBTITLE', EMPTY_OBJECT);
  }
  ASA_STANDALONE_CALENDAR_PROVIDER_APPLE_TITLE() {
    return this._translate('ASA_STANDALONE_CALENDAR_PROVIDER_APPLE_TITLE', EMPTY_OBJECT);
  }
  ASA_STANDALONE_CALENDAR_PROVIDER_APPLE_SUBTITLE() {
    return this._translate('ASA_STANDALONE_CALENDAR_PROVIDER_APPLE_SUBTITLE', EMPTY_OBJECT);
  }
  ASA_STANDALONE_CHAT_WAITLIST_USER_MESSAGE() {
    return this._translate('ASA_STANDALONE_CHAT_WAITLIST_USER_MESSAGE', EMPTY_OBJECT);
  }
}
//# sourceMappingURL=UouChatMessages.js.map